import React from 'react'
import { Button, Icon, makeStyles, Typography } from '@material-ui/core'
import clsx from 'clsx'
import AddressBlock from './AddressBlock'

const useStyles = makeStyles(() => ({
	clientWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 16,
		borderRadius: 6,
		background: '#F9F9F9'
	},
	userIcon: {
		width: '16px',
		height: '18px',
		'&:before': {
			color: '#777679'
		}
	}
}))

const ClientBlock = ({ household, onClearHousehold, displayAddress = true }) => {
	const classes = useStyles()

	if (!household) {
		return null
	}

	const handleOnClearHousehold = () => {
		if (onClearHousehold) {
			onClearHousehold()
		}
	}

	return (
		<div className={classes.clientWrapper}>
			<div style={{ display: 'flex', alignItems: 'flex-start' }}>
				<Icon
					className={clsx([classes.userIcon, 'far fa-user'])}
					style={{
						fontSize: '16px',
						padding: '2px',
						marginTop: '3px',
						marginRight: '24px'
					}}
				/>
				<div>
					{displayAddress ? (
						<AddressBlock household={household} />
					) : (
						<Typography variant="body2">{household?.account.full_name || 'No name'}</Typography>
					)}
				</div>
			</div>
			<div>
				<Button color="secondary" variant="outlined" onClick={handleOnClearHousehold}>
					Change Client
				</Button>
			</div>
		</div>
	)
}

export default ClientBlock
